import api from './api'
import axios from './axios'


export const login = async (username, password) => {
  const response = await api.post('/auth/login', { email: username, password })
  return response.data
}


export const refreshToken = async (refreshToken) => {
  const response = await axios.post('/auth/refresh-token', { refresh_token: refreshToken })
  return response.data
}


export const register = async (userData) => {
  const response = await api.post('/auth/register', userData)
  return response.data
}


export const getProfile = async () => {
  const response = await api.get('/auth/profile')
  return response.data
}


export const updateProfile = async (profileData) => {
  const response = await api.put('/auth/profile', profileData)
  return response.data
}

export const getTemplatePrefills = async () => {
  const response = await api.get('/auth/template-prefills')
  return response.data
}

export const updateTemplatePrefill = async (templateId, values) => {
  const response = await api.put(`/auth/template-prefills/${templateId}`, { values })
  return response.data
}


export const forgotPassword = async (email) => {
  const response = await api.post('/auth/forgot-password', { email })
  return response.data
}


export const resetPassword = async (token, password) => {
  const response = await api.post('/auth/reset-password', { token, password })
  return response.data
}


export const updatePassword = async (password) => {
  const response = await api.put('/auth/password', { password })
  return response.data
}


export const verifyEmail = async (token) => {
  const response = await api.post('/auth/verify', { token })
  return response.data
}


export const resendVerificationEmail = async (email) => {
  const response = await api.post('/auth/verify/resend', { email })
  return response.data
}


export const requestEmailChange = async (email) => {
  const response = await api.post('/auth/email-change', { email })
  return response.data
}


export const confirmEmailChange = async (token) => {
  const response = await api.post('/auth/email-change/confirm', { token })
  return response.data
}


export const killSessions = async () => {
  const response = await api.delete('/auth/kill-sessions')
  return response.data
}

export const deleteUser = async () => {
  const response = await api.delete('/auth/delete-me')
  return response.data
}

/**
 * Sendet eine Anfrage zum Versenden eines Magic-Links
 * 
 * @param {string} email - E-Mail des Benutzers
 * @returns {Promise} - Promise mit der Antwort vom Server
 */
export const requestMagicLink = async (email) => {
  const response = await api.post('/auth/magic-link', { email });
  return response.data;
};

/**
 * Markiert das Tutorial als abgeschlossen
 * @returns {Promise} - Promise mit der Antwort vom Server
 */
export const markTutorialComplete = async () => {
  const response = await api.post('/auth/tutorial-complete');
  return response.data;
}; 
